import Vue from 'vue'
// @ts-ignore
import NoSsr from 'vue-no-ssr'
import { mapActions, mapGetters, mapState } from 'vuex'
import NavGroup from './NavGroup/NavGroup.vue'
import throttle from 'lodash/throttle'
import {
  BLOG,
  BOOKMARKS,
  BROWSE_JOBS,
  BROWSE_JOBS_BY_SKILL,
  CHAT,
  DASHBOARD,
  FREELANCERS_LIST,
  HIRE_LANDING,
  JOB_ADD,
  JOB_EDIT,
  LANDING,
  MY_JOBS,
  POST_A_JOB,
  PREMIUM,
  PROFILE_SETTINGS,
  REFERRALS,
  REGISTRATION_COMPLETE,
  SALARY_STATISTICS,
  SERVICE_ADD,
  SERVICE_BY_SKILL,
  SERVICE_EDIT,
  SERVICE_MY,
  SERVICES,
  SETTINGS,
  USER_NOTIFICATIONS,
  VACANCIES,
  VACANCIES_MY,
  VACANCY_ADD,
  VACANCY_EDIT,
  WALLETS,
} from '@/constants/routes'
import { Roles } from '@/constants/user/roles'
import responseMixin from '@/mixins/responseMixin'
import rolebleMixin from '@/mixins/rolebleMixin'
import zendeskMixin from '@/mixins/zendeskMixin'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'
import { disablePageScroll, enablePageScroll } from '@/utils/scrollLock'

export default Vue.extend<any, any, any, any>({
  mixins: [responseMixin, rolebleMixin, zendeskMixin],
  components: {
    NoSsr,
    NavGroup,
  },
  props: {
    isPrivatePage: Boolean,
  },
  data() {
    return {
      menuOpen: false,
      isLoading: false,
      sublistCatalogOpen: false,
      sublistMoreOpen: false,
      DASHBOARD,
      JOB_ADD,
      BLOG,
      BROWSE_JOBS,
      SERVICES,
      VACANCIES,
      BOOKMARKS,
      USER_NOTIFICATIONS,
      CHAT,
      PROFILE_SETTINGS,
      SETTINGS,
      SERVICE_BY_SKILL,
      BROWSE_JOBS_BY_SKILL,
      SERVICE_MY,
      MY_JOBS,
      VACANCIES_MY,
      WALLETS,
      PREMIUM,
      REFERRALS,
      LANDING,
      POST_A_JOB,
      FREELANCERS_LIST,
      HIRE_LANDING,
      SALARY_STATISTICS,
      pageLoaded: false,
      scrolled: false,
      switching: false,
      isWorker: true,
    }
  },
  computed: {
    ...mapState<RootState>({
      isLoggedIn: (state: RootState) => state.app.authorized,
      unreadCount: (state: any) => state.notifications?.unreadCount || 0,
      chatInitialized: (state: RootState) => state.chatNew?.initialized,
      chatConnected: (state: RootState) => state.chatNew?.connected,
      unreadChatMsgMap: (state: RootState) => state.chatNew?.unreadMap || {},
      userId: (state: any) => state.user?.id,
      companyLogo: (state: any) => state.user?.companyLogo,
      avatar: (state: any) => state.user?.avatar,
      isProfileLoading: (state: any) => state.user?.profile.isLoading,
      type: (state: any) => state.user?.type,
      profiles: (state: any) => state.user?.profiles,
      customerIsNewbie: (state: any) => state.user?.customerIsNewbie,
    }),
    ...mapGetters({
      tokenInfo: 'user/tokenInfo',
      activeProfile: 'user/activeProfile',
    }),
    isCustomerFromToken() {
      return this.activeProfile === Roles.CUSTOMER
    },
    hasPostJobBtn() {
      const job_routes = [JOB_ADD, JOB_EDIT, VACANCY_ADD, VACANCY_EDIT, POST_A_JOB]
      const customerIsNewbie = this.$route.name === DASHBOARD && this.customerIsNewbie && this.isLoggedIn
      return !job_routes.includes(this.$route.name) && !customerIsNewbie
    },
    hasPostGigBtn() {
      const job_routes = [SERVICE_ADD, SERVICE_EDIT]
      return !job_routes.includes(this.$route.name)
    },
    hasPostBtnsSection() {
      return this.isFreelancer ? this.hasPostGigBtn : this.hasPostJobBtn
    },
    hasPostHeaderBtn() {
      return (!this.isProfileLoading || !this.isLoggedIn || this.tokenInfo) && this.hasPostBtnsSection
    },
    isPostJobBtn() {
      return !this.activeRole || this.isCustomer || (this.tokenInfo && this.isCustomerFromToken)
    },
    multipleRole() {
      return this.profiles[Roles.FREELANCER] && this.profiles[Roles.CUSTOMER]
    },
    isBrowsVacancies() {
      return this.$route.name === VACANCIES
    },
    isServices() {
      return [SERVICES, SERVICE_BY_SKILL].includes(this.$route.name)
    },
    isBrowseJobs() {
      return [BROWSE_JOBS, BROWSE_JOBS_BY_SKILL].includes(this.$route.name)
    },
    withoutActions() {
      return this.$route.name === REGISTRATION_COMPLETE
    },
    name() {
      return this.$store.getters['user/name']
    },
    avatarImage() {
      return this.isCompanyCustomer ? this.companyLogo : this.avatar
    },
    isChangeRoleDisabled() {
      return this.switching || this.isProfileLoading
    },
    isLoggedInLazy() {
      return this.pageLoaded && this.isLoggedIn
    },
    scrollThreshold() {
      return this.xsAndDown ? 10 : 24
    },
    formattedUnreadCount() {
      return this.$store.getters['chatNew/formattedUnreadCount'] || 0
    },
    // isPrivatePage () {
    //   if (this.$route.meta.withoutLayout) {
    //     return false
    //   }
    // const layout = typeof this.$route.meta.layout === 'function' ? this.$route.meta.layout(this.isLoggedIn) : this.$route.meta.layout
    // switch (layout) {
    //   case 'public':
    //   case 'public-new': {
    //     return false
    //   }
    //   case 'private-new': {
    //     return true
    //   }
    // }
    //   if (this.$route.matched.some((record: any) => record.meta.requiresAuth) && this.isLoggedIn) {
    //     return true
    //   }
    //   if (this.$route.meta.requireNoAuth) {
    //     return false
    //   }
    //   return this.isLoggedIn
    // },
    mainLink() {
      return this.isPrivatePage ? { name: DASHBOARD } : '/'
    },
    changeRoleLabel() {
      const firstPart = 'Change to'
      if (this.isWorker) {
        return `${firstPart} Customer`
      }
      return `${firstPart} Freelancer`
    },
    isNewYear() {
      const isDevEnv = process.env.VUE_APP_MODE === 'dev'
      const currentDate = new Date()
      const dateLeft = isDevEnv ? 15 : 23
      const dateRight = isDevEnv ? 8 : 14
      if (currentDate.getMonth() === 11) return currentDate.getDate() > dateLeft
      if (currentDate.getMonth() === 0) return currentDate.getDate() < dateRight
      return false
    },
  },
  watch: {
    isTabletLx() {
      if (!this.isTabletLx) {
        this.menuOpen = false
      }
    },
    menuOpen() {
      if (this.menuOpen) {
        this.$nextTick(() => {
          disablePageScroll()
        })
      } else {
        enablePageScroll()
      }
    },
    activeRole: {
      handler() {
        this.isWorker = this.activeRole === Roles.FREELANCER
      },
      immediate: true,
    },
    '$route.name': {
      handler() {
        this.closeMenu()
      },
    },
  },
  mounted() {
    this.pageLoaded = true
    if (this.$route.query.redirect) {
      this.openLogin()
    }
    window.addEventListener('scroll', this.onScrollPage)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrollPage)
    enablePageScroll()
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
      logout: 'app/logout',
      switchRole: 'user/switchRole',
    }),
    closeMenu() {
      this.menuOpen = false
      this.sublistCatalogOpen = false
      this.sublistMoreOpen = false
    },
    async onLogoutMobile() {
      await this.onLogout()
      this.onClickMenu()
    },
    onClickSupport() {
      if (!this.isZendeskLoading) {
        this.openZendesk('My account')
        this.onClickMenu()
      }
    },
    openLogin() {
      this.closeMenu()
      this.openModal({
        component: 'lx-login-modal',
        id: 'lx-login-modal',
        props: {
          fromType: 'header',
        },
      })
      googleAnalyticsV2.send({
        event: 'login-button-click',
        'event-content': 'header',
      })
    },
    openSignUp() {
      this.closeMenu()
      this.openModal({
        component: 'lx-sign-up-modal',
        props: {
          fromType: 'header',
        },
      })
      googleAnalyticsV2.send({
        event: 'register-button-click',
        'event-content': 'header',
      })
    },
    async onLogout() {
      this.isLoading = true
      this.closeMenu()
      if (this.$route.name !== LANDING) {
        this.$router.push({ name: LANDING })
      }
      await this.logout(true).catch((e: any) => console.error(e))
      this.isLoading = false
    },
    onClickWithCloseMenu() {
      if (this.menuOpen) {
        this.onClickMenu()
      }
    },
    onToggleMobileMenuClick() {
      this.menuOpen = !this.menuOpen
    },
    onClickMenu() {
      this.menuOpen = false
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
    },
    onScrollPage: throttle(function (this: any) {
      this.scrolled = window.scrollY >= this.scrollThreshold
    }, 30),
    onCreateGigClick() {
      googleAnalyticsV2.send({
        event: 'click-on-button-post-gig',
      })
      this.$router.push({ name: SERVICE_ADD, query: { createGigFrom: 'profile' } }).catch(() => {})
    },
    onPostJobClick() {
      googleAnalyticsV2.send({
        event: 'post-job-button',
      })
      this.$router.push({ name: POST_A_JOB, query: { fromType: 'add-job-from-profile' } }).catch(() => {})
    },
    async onChangeRole() {
      if (!this.switching) {
        this.onClickWithCloseMenu()
        try {
          this.switching = true
          if (this.multipleRole) {
            const role = this.isWorker ? Roles.CUSTOMER : Roles.FREELANCER
            await this.switchRole(role)
            googleAnalyticsV2.send({
              event: 'change-role',
              'event-content': role === Roles.FREELANCER ? 'talent' : 'customer',
            })
          } else {
            this.openModal({
              component: 'lx-lazy-modal',
              props: {
                factory: import(/* webpackChunkName: "add-role-modal" */ '@/modals/auth/AddRole/AddRole.vue'),
                title: 'Freelancer Registration',
              },
            })
          }
        } catch (e) {
          this.isWorker = this.activeRole === Roles.FREELANCER
          this.parseError(e)
        } finally {
          this.switching = false
        }
      }
    },
  },
})
